var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("view-page", {
    attrs: {
      title: _vm.title,
      "delete-button": _vm.canBeDeleted,
      "delete-dialog-title": _vm.$t("DeleteItem"),
      "delete-dialog-content":
        _vm.$t("DeleteConfirmation") +
        " " +
        _vm.$tc("Template", 1) +
        " " +
        _vm.title +
        "?",
      loading: _vm.loading,
      "permission-name": "asset_reservation_template"
    },
    on: { editItem: _vm.editItem, deleteItem: _vm.deleteItem },
    scopedSlots: _vm._u([
      {
        key: "leftSide",
        fn: function() {
          return _vm._l(_vm.fields, function(field) {
            return _vm.fields
              ? _c("view-page-data-field", {
                  key: field.template,
                  attrs: {
                    icon: field.icon,
                    label: field.label,
                    data: field.data
                  }
                })
              : _vm._e()
          })
        },
        proxy: true
      },
      {
        key: "rightSide",
        fn: function() {
          return [
            _c("reservation-template-fields-list", {
              attrs: {
                "request-fields": _vm.requestFields,
                "action-type": "view"
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a1c28e7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1c28e7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Templates/ReservationTemplateDetails.vue
// module id = null
// module chunks = 